define('../app/fukit/behavior/update.task.list.badge.options.behavior',['require','exports','module','marionette','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var Mn               = require('marionette'),
      Radio            = require('backbone.radio'),
      TASKLIST_CHANNEL = Radio.channel('UI.taskList');

  var UpdateTaskListBadgeOptionsBehavior = Mn.Behavior.extend({
    setBadgeOptions: function(cayuseTaskListCollection) {
      var taskCount = cayuseTaskListCollection ? cayuseTaskListCollection.length : 0;

      taskCount === 0 ? this.view.$el.addClass('muted') : this.view.$el.removeClass('muted');

      this.view.badge = taskCount > 0;
      this.view.badgeColor = taskCount > 0 && taskCount < 100 ? 'red' : 'badge-gray';
      this.view.badgeText = taskCount > 0 && taskCount < 100 ? String(taskCount) : '99+';
    },

    onFirstBeforeRender: function() {
      var cayuseTaskListCollection = TASKLIST_CHANNEL.request('getTaskListSidebar').getCayuseTaskListCollection();

      this.setBadgeOptions(cayuseTaskListCollection);
      this.listenTo(cayuseTaskListCollection, 'sync', this.setBadgeOptions, cayuseTaskListCollection);
    },
  });

  module.exports = UpdateTaskListBadgeOptionsBehavior;
});

